export default __webpack_public_path__ + "static/media/close-drawer.fd55abee.svg";